import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import { styled } from '@mui/system';
import React, { useState } from 'react';
import { useCheckSecondPasswordMutation } from '../../services/controllers/user/UserQueries';

interface SecondPasswordDialogProps {
  open: boolean;
  onClose?: () => void;
  onSuccess: () => void;
  description?: string;
}

const SecondPasswordDialog: React.FC<SecondPasswordDialogProps> = ({ open = false, description, onClose, onSuccess }) => {
  const [password, setPassword] = useState('');
  const [isShowPassword, setShowPassword] = useState(false);

  const { mutate: checkSecondPassMutate, isLoading } = useCheckSecondPasswordMutation();

  const onChange = (value: string) => {
    setPassword(value);
  };

  const verifyPassword = async () => {
    checkSecondPassMutate(
      { password },
      {
        onSuccess: () => {
          onSuccess();
          if (onClose) {
            onClose();
          }
        },
        onSettled: () => setPassword(''),
      },
    );
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">Xác nhận mật khẩu cấp 2</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
        <DialogContentText my={2} id="alert-dialog-sub-description">
          Hãy nhập mật khẩu cấp 2 để xác nhận hành động của bạn.
        </DialogContentText>

        <PasswordGroup>
          <FormInput
            label="Mật khẩu cấp 2"
            name="password"
            type={isShowPassword ? 'text' : 'password'}
            onChange={(e) => onChange(e.target.value)}
            value={password}
            variant="outlined"
            fullWidth
            disabled={isLoading}
          />
          <IconButton onClick={() => setShowPassword(!isShowPassword)} edge="end">
            {isShowPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </PasswordGroup>
      </DialogContent>
      <DialogActions>
        <Button sx={{ mr: 2 }} disabled={!password || isLoading} onClick={verifyPassword} autoFocus>
          {isLoading ? <CircularProgress size={24} /> : 'Xác nhận'}
        </Button>
        {onClose ? <Button onClick={onClose}>Huỷ bỏ</Button> : null}
      </DialogActions>
    </Dialog>
  );
};

const PasswordGroup = styled('div')({
  position: 'relative',
  '& input': {
    paddingRight: '60px',
  },
  '& .MuiIconButton-root': {
    position: 'absolute',
    top: 23,
    right: 20,
  },
});

const FormInput = styled(TextField)(() => ({
  marginTop: 16,
  marginBottom: 16,
}));

export default SecondPasswordDialog;
